import { getRegionalPersonalisedSavingsThreshold } from 'luxPlus/constants/base'

type PersonalisedSavingCheck =
  | { showPersonalised: true; firstName: string; personalSaving: number }
  | { showPersonalised: false; firstName: undefined; personalSaving: undefined }

/**
 * Whether the user qualifies for the personalised savings stat card variant.
 * True when we have a known user with past savings at or above the region's threshold.
 * Returns a discriminated union so callers can access narrowed `personalSaving`
 * and `firstName` when `showPersonalised` is true.
 */
function checkPersonalisedSaving(firstName?: string, personalSaving?: number, regionCode?: string): PersonalisedSavingCheck {
  if (firstName && personalSaving !== undefined && personalSaving >= getRegionalPersonalisedSavingsThreshold(regionCode)) {
    return { showPersonalised: true, firstName, personalSaving }
  }
  return { showPersonalised: false, firstName: undefined, personalSaving: undefined }
}

export default checkPersonalisedSaving
export type { PersonalisedSavingCheck }
